export type StripeConnectStatus =
  | 'not_connected'
  | 'action_required'
  | 'onboarding_required'
  | 'pending_verification'
  | 'fully_connected';

/** Fields used to derive Stripe Connect Express status from org list payloads. */
export type StripeConnectStatusFields = {
  stripeConnectExpressAccountId?: string | null;
  stripeConnectExpressAccountActionRequired?: boolean | null;
  stripeConnectExpressDetailsSubmitted?: boolean | null;
  stripeConnectExpressChargesEnabled?: boolean | null;
  stripeConnectExpressPayoutsEnabled?: boolean | null;
};

/**
 * Mirrors host Stripe Connect page status precedence:
 * action required → onboarding → pending verification → fully connected.
 */
export function resolveStripeConnectStatus(
  fields: StripeConnectStatusFields | null | undefined,
): StripeConnectStatus {
  if (!fields?.stripeConnectExpressAccountId) return 'not_connected';
  if (fields.stripeConnectExpressAccountActionRequired) return 'action_required';
  if (!fields.stripeConnectExpressDetailsSubmitted) return 'onboarding_required';
  if (!fields.stripeConnectExpressChargesEnabled || !fields.stripeConnectExpressPayoutsEnabled) {
    return 'pending_verification';
  }
  return 'fully_connected';
}
